export default "__VITE_ASSET__CTSFdniu__"